/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncuestaPacienteModelDto } from '../../models/encuesta-paciente-model-dto';

export interface DoctorEncuestasControllerObtenerRespuestasPaciente$Params {

/**
 * UUID del paciente para obtener sus respuestas de encuesta
 */
  uuidPaciente: string;
}

export function doctorEncuestasControllerObtenerRespuestasPaciente(http: HttpClient, rootUrl: string, params: DoctorEncuestasControllerObtenerRespuestasPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<EncuestaPacienteModelDto>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerObtenerRespuestasPaciente.PATH, 'get');
  if (params) {
    rb.path('uuidPaciente', params.uuidPaciente, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EncuestaPacienteModelDto>;
    })
  );
}

doctorEncuestasControllerObtenerRespuestasPaciente.PATH = '/api/doctor-encuestas/obtener-respuestas-paciente/{uuidPaciente}';
